import { useId } from 'react';
import Svg, { Defs, G, LinearGradient, Mask, Path, Stop, SvgProps } from 'react-native-svg';

export function SvgGooglePlay(props: SvgProps) {
  const idA = useId();
  const idB = useId();
  const idC = useId();
  const idD = useId();
  const idE = useId();

  return (
    <Svg aria-label="Get our app on Google Play" width={180} height={53} fill="none" {...props}>
      <Mask
        id={idA}
        width={180}
        height={53}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <Path fill="#fff" d="M179.263 0H.737v53h178.526V0Z" />
      </Mask>
      <G mask={`url(#${idA})`}>
        <Path
          fill="#000"
          d="M172.651 0H7.349C3.697 0 .737 2.966.737 6.625v39.75C.737 50.034 3.697 53 7.35 53h165.302c3.652 0 6.612-2.966 6.612-6.625V6.625c0-3.659-2.96-6.625-6.612-6.625Z"
        />
        <Path
          fill="#A6A6A6"
          d="M172.651 1.06c1.473 0 2.886.586 3.927 1.63a5.57 5.57 0 0 1 1.627 3.935v39.75a5.57 5.57 0 0 1-1.627 3.935 5.547 5.547 0 0 1-3.927 1.63H7.349a5.549 5.549 0 0 1-3.927-1.63 5.57 5.57 0 0 1-1.627-3.935V6.625A5.57 5.57 0 0 1 3.422 2.69a5.549 5.549 0 0 1 3.927-1.63h165.302Zm0-1.06H7.349a6.606 6.606 0 0 0-4.675 1.94A6.632 6.632 0 0 0 .737 6.625v39.75c0 1.757.697 3.442 1.937 4.685A6.606 6.606 0 0 0 7.349 53h165.302a6.604 6.604 0 0 0 4.675-1.94 6.632 6.632 0 0 0 1.937-4.685V6.625a6.632 6.632 0 0 0-1.937-4.685A6.604 6.604 0 0 0 172.651 0Z"
        />
        <Path
          fill="#fff"
          stroke="#fff"
          strokeMiterlimit={10}
          strokeWidth={0.253}
          d="M63.446 13.568a3.61 3.61 0 0 1-.991 2.65 3.835 3.835 0 0 1-2.91 1.166 3.961 3.961 0 0 1-2.922-1.192 4.231 4.231 0 0 1 0-5.91 4.176 4.176 0 0 1 4.549-.861c.477.196.902.5 1.243.888l-.701.702a2.645 2.645 0 0 0-2.169-.954 3.169 3.169 0 0 0-2.617 1.414 3.184 3.184 0 0 0 1.98 4.876 3.169 3.169 0 0 0 2.859-.818 2.547 2.547 0 0 0 .661-1.616h-2.883v-.954h3.849c.03.202.047.405.052.61ZM69.503 10.254h-3.57v2.517h3.253v.954h-3.254v2.518h3.571v.98h-4.602v-7.95h4.602v.98ZM73.84 17.223h-1.018v-6.97H70.6v-.98h5.515v.98H73.84v6.97ZM80.003 17.223v-7.95h1.018v7.95h-1.018ZM85.544 17.223h-1.018v-6.97h-2.222v-.98h5.449v.98h-2.209v6.97ZM98.08 16.192a4.113 4.113 0 0 1-2.908 1.208 4.106 4.106 0 0 1-2.91-1.208 4.298 4.298 0 0 1 0-5.883 3.876 3.876 0 0 1 2.91-1.206 3.96 3.96 0 0 1 2.909 1.206 4.07 4.07 0 0 1 1.164 2.941 3.981 3.981 0 0 1-1.164 2.942Zm-5.064-.663a3.026 3.026 0 0 0 4.311 0 3.369 3.369 0 0 0 0-4.558 3.028 3.028 0 0 0-3.324-.668c-.37.155-.705.382-.987.668a3.37 3.37 0 0 0 0 4.558ZM100.685 17.223v-7.95h1.23l3.861 6.188V9.274h1.018v7.95h-1.057l-4.034-6.48v6.479h-1.018Z"
        />
        <Path
          fill="#fff"
          d="M90.846 28.82a5.626 5.626 0 0 0-3.127.959 5.643 5.643 0 0 0-2.382 5.8 5.648 5.648 0 0 0 1.548 2.886 5.631 5.631 0 0 0 6.142 1.21 5.652 5.652 0 0 0 3.465-5.223 5.561 5.561 0 0 0-1.63-4.016 5.54 5.54 0 0 0-4.016-1.616Zm0 9.05a3.406 3.406 0 0 1-3.316-1.937 3.424 3.424 0 0 1 .58-3.802 3.41 3.41 0 0 1 5.91 2.32 3.267 3.267 0 0 1-.867 2.38 3.253 3.253 0 0 1-2.307 1.039Zm-12.325-9.05a5.626 5.626 0 0 0-3.127.959 5.655 5.655 0 0 0-.833 8.687 5.63 5.63 0 0 0 6.142 1.208 5.636 5.636 0 0 0 2.523-2.085c.617-.93.945-2.021.942-3.138a5.561 5.561 0 0 0-1.632-4.015 5.54 5.54 0 0 0-4.015-1.616Zm0 9.05a3.406 3.406 0 0 1-3.316-1.937 3.424 3.424 0 0 1 .58-3.802 3.41 3.41 0 0 1 3.743-.854 3.413 3.413 0 0 1 2.167 3.174 3.265 3.265 0 0 1-1.916 3.133 3.25 3.25 0 0 1-1.258.286ZM63.87 30.556v2.385h5.713a5 5 0 0 1-1.323 3.008 5.844 5.844 0 0 1-4.417 1.749 6.341 6.341 0 0 1-4.488-1.863 6.367 6.367 0 0 1 0-8.995 6.34 6.34 0 0 1 4.488-1.862 6.13 6.13 0 0 1 4.338 1.709l1.68-1.683a8.33 8.33 0 0 0-5.991-2.411 8.724 8.724 0 0 0-6.4 2.439 8.759 8.759 0 0 0-2.681 6.312 8.772 8.772 0 0 0 2.681 6.313 8.739 8.739 0 0 0 6.4 2.439 8.012 8.012 0 0 0 6.096-2.451 7.96 7.96 0 0 0 2.063-5.605 8.329 8.329 0 0 0-.119-1.484h-8.04Zm59.918 1.855a5.283 5.283 0 0 0-4.813-3.59 5.278 5.278 0 0 0-3.863 1.667 5.304 5.304 0 0 0-1.427 3.963 5.612 5.612 0 0 0 1.082 3.366 5.583 5.583 0 0 0 9.18-.226l-1.918-1.324a3.183 3.183 0 0 1-2.763 1.55 2.84 2.84 0 0 1-2.725-1.71l7.525-3.113-.278-.583Zm-7.67 1.881a3.11 3.11 0 0 1 .783-2.27 3.1 3.1 0 0 1 2.166-1.029 2.165 2.165 0 0 1 2.076 1.206l-5.025 2.093Zm-6.109 5.46h2.473V23.188h-2.473V39.75Zm-4.047-9.673h-.092a3.898 3.898 0 0 0-2.963-1.325 5.626 5.626 0 0 0-3.805 1.744 5.65 5.65 0 0 0 0 7.787 5.627 5.627 0 0 0 3.805 1.745 3.803 3.803 0 0 0 2.963-1.325h.092v.808c0 2.16-1.15 3.312-3.002 3.312a3.117 3.117 0 0 1-2.843-2l-2.142.887a5.297 5.297 0 0 0 4.985 3.34c2.896 0 5.29-1.71 5.29-5.87v-10.03h-2.288v.927Zm-2.843 7.79a3.42 3.42 0 0 1-2.274-5.753 3.406 3.406 0 0 1 2.274-1.07 3.16 3.16 0 0 1 3.015 3.405 3.154 3.154 0 0 1-3.015 3.419Zm32.254-14.68h-5.925V39.75h2.473v-6.28h3.452a5.139 5.139 0 0 0 5.085-3.084 5.163 5.163 0 0 0-3.006-6.918 5.139 5.139 0 0 0-2.079-.28Zm0 7.95h-3.452v-5.645h3.505a2.83 2.83 0 0 1 2.83 2.836 2.845 2.845 0 0 1-1.747 2.62 2.83 2.83 0 0 1-1.083.215l-.053-.026Zm15.26-2.372a4.608 4.608 0 0 0-4.403 2.53l2.182.915a2.354 2.354 0 0 1 2.261-1.206 2.377 2.377 0 0 1 2.645 2.134v.159a5.518 5.518 0 0 0-2.579-.636c-2.354 0-4.761 1.325-4.761 3.736a3.849 3.849 0 0 0 1.287 2.695 3.809 3.809 0 0 0 2.826.949 3.498 3.498 0 0 0 3.148-1.617h.079v1.325h2.38v-6.373c0-2.902-2.195-4.584-5.012-4.584l-.053-.027Zm-.304 9.076c-.806 0-1.931-.41-1.931-1.404 0-1.325 1.402-1.776 2.645-1.776a4.382 4.382 0 0 1 2.248.557 2.986 2.986 0 0 1-2.909 2.65l-.053-.027Zm14.044-8.692-2.83 7.182h-.079l-2.936-7.182h-2.645l4.404 10.044-2.513 5.578h2.579l6.771-15.622h-2.751Zm-22.216 10.6h2.459V23.19h-2.459V39.75Z"
        />
        <Path
          fill={`url(#${idB})`}
          d="M14.544 9.991a2.653 2.653 0 0 0-.622 1.855v29.31a2.574 2.574 0 0 0 .622 1.854l.092.106L31.022 26.7v-.397L14.636 9.898l-.092.093Z"
        />
        <Path
          fill={`url(#${idC})`}
          d="m36.443 32.17-5.422-5.472V26.3l5.422-5.472.12.08 6.492 3.683c1.852 1.047 1.852 2.77 0 3.83l-6.466 3.683-.146.066Z"
        />
        <Path
          fill={`url(#${idD})`}
          d="M36.6 32.092 31.02 26.5 14.543 43.01a2.14 2.14 0 0 0 2.737.092l19.32-11.01Z"
        />
        <Path
          fill={`url(#${idE})`}
          d="M36.6 20.907 17.28 9.91a2.127 2.127 0 0 0-2.737.08L31.02 26.498l5.58-5.592Z"
        />
        <Path
          fill="#000"
          d="M36.442 31.973 17.28 42.903a2.192 2.192 0 0 1-2.645 0l-.092.094.092.106a2.193 2.193 0 0 0 2.645 0L36.6 32.092l-.158-.12Z"
          opacity={0.2}
        />
        <Path
          fill="#000"
          d="M14.542 42.825a2.653 2.653 0 0 1-.582-1.868v.199a2.574 2.574 0 0 0 .622 1.855l.093-.093-.133-.093ZM43.054 28.223l-6.612 3.75.12.119 6.492-3.684a2.315 2.315 0 0 0 1.402-1.908 2.466 2.466 0 0 1-1.402 1.723Z"
          opacity={0.12}
        />
        <Path
          fill="#fff"
          d="m17.28 10.097 25.774 14.681a2.46 2.46 0 0 1 1.402 1.723 2.322 2.322 0 0 0-1.402-1.908L17.28 9.912c-1.838-1.06-3.358-.186-3.358 1.934v.2c.04-2.12 1.52-2.995 3.358-1.949Z"
          opacity={0.25}
        />
      </G>
      <Defs>
        <LinearGradient
          id={idB}
          x1={29.567}
          x2={7.333}
          y1={11.541}
          y2={33.732}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#00A0FF" />
          <Stop offset={0.01} stopColor="#00A1FF" />
          <Stop offset={0.26} stopColor="#00BEFF" />
          <Stop offset={0.51} stopColor="#00D2FF" />
          <Stop offset={0.76} stopColor="#00DFFF" />
          <Stop offset={1} stopColor="#00E3FF" />
        </LinearGradient>
        <LinearGradient
          id={idC}
          x1={45.475}
          x2={13.486}
          y1={26.499}
          y2={26.499}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE000" />
          <Stop offset={0.41} stopColor="#FFBD00" />
          <Stop offset={0.78} stopColor="orange" />
          <Stop offset={1} stopColor="#FF9C00" />
        </LinearGradient>
        <LinearGradient
          id={idD}
          x1={33.572}
          x2={3.415}
          y1={29.547}
          y2={59.632}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FF3A44" />
          <Stop offset={1} stopColor="#C31162" />
        </LinearGradient>
        <LinearGradient
          id={idE}
          x1={10.39}
          x2={23.852}
          y1={0.237}
          y2={13.673}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#32A071" />
          <Stop offset={0.07} stopColor="#2DA771" />
          <Stop offset={0.48} stopColor="#15CF74" />
          <Stop offset={0.8} stopColor="#06E775" />
          <Stop offset={1} stopColor="#00F076" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
